<div class="linq-dialog">
	<div class="linq-dialog__header">
		<h3 class="linq-heading" [innerHTML]="title"></h3>
	</div>
	<sl-feedback-panel variant="error" context="modal"></sl-feedback-panel>
	<sl-feedback-panel variant="warn" context="modal"></sl-feedback-panel>
	<div class="linq-dialog__content linq-dialog__content_scroll">
		<mat-stepper linear #stepper>
			<mat-step [completed]="importCompleted()">
				<ng-template matStepLabel>Select Import File</ng-template>
				<div class="row searchParams" style="margin-bottom: 25px; text-align:center;">
					<p style="margin-top: 70px">Files must be in .csv format</p>
					<button name="fileImport" mat-flat-button color="primary" appearance="fill" id="importCOAFile"
						class="linq-button--primary export-button mx-1 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary mat-mdc-button-base"
						(click)="fileInput.click()" style="color: #fff;">
						<i class="fa fa-upload" aria-hidden="true" style="margin-right: 5px"></i>
						<span class="">Select File To Import</span>
					</button>
					<input type="file" #fileInput (change)="onFileSelected($event)" accept=".csv" style="display: none;">
				</div>
			</mat-step>

			<mat-step [completed]="fixedErrors()">
				<ng-template matStepLabel>Fix Errors</ng-template>
				<div>
					<sl-table [data]="data" [config]="tableConfig" [noDataText]="noDataMessage"></sl-table>
				</div>
			</mat-step>
		</mat-stepper>
	</div>
	<mat-dialog-actions class="linq-dialog__actions">
		<button (click)="onCancelClick()" mat-stroked-button class="linq-button--secondary linq-button--secondary-stroked mat-mdc-button-base"
			*ngIf="showCancel">
			Cancel
		</button>
		<button (click)="generateReport(true)" mat-stroked-button class="linq-button--primary linq-button--primary-stroked mat-mdc-button-base"
			*ngIf="canShowReportButton()">
			Generate PDF Report
		</button>
		<button (click)="generateReport(false)" mat-stroked-button class="linq-button--primary linq-button--primary-stroked mat-mdc-button-base"
			*ngIf="canShowReportButton()">
			Generate Excel Report
		</button>
		<span class="spacer"></span>
		<button class="linq-button--secondary linq-button--primary-stroked mat-mdc-button-base" [color]="okColor" *ngIf="stepper.selectedIndex !== 0"
			mat-stroked-button (click)="goBack(stepper)">
			Back
		</button>
		<button class="linq-button--primary linq-button--primary-stroked mat-mdc-button-base" [color]="okColor" [disabled]="!importCompleted()"
			*ngIf="stepper.selectedIndex !== stepper.steps.length-1" mat-stroked-button (click)="goForward(stepper)">
			Next
		</button>
		<button class="linq-button--primary linq-button--primary-stroked mat-mdc-button-base" *ngIf="stepper.selectedIndex === stepper.steps.length-1"
			[color]="buttonColor" (click)="onSave()" mat-flat-button [disabled]="saveDisabled()" cdkFocusInitial>
			Import
		</button>
	</mat-dialog-actions>
</div>